<template>
  <div :class="{'campaignViews':true,'review-formWidth': type === 'list'}">
    <div :class="{ 'campaignViews-div': type === 'pop' }">
      <div v-for="(item, i) in list" :key="i">
        <el-form-item
          :class="{'custom-review-item':true,'custom-review-item-combo':type==='combo'}"
          :label="i === 0 && type === 'list' ? businessType === 11 ? 'Youtube Comments' : $t('messages.createCampaign.create64') : ''"
        >
          <template v-if="mode !== 'detail'">
            <img
              src="../../../assets/img/review-add.png"
              alt="add review"
              class="review-item-img"
              @click="handleReviewAdd(i, 0)"
              v-if="((i === 0 && page === 1) || allList.length === 1) && type === 'list'"
            />
            <img
              src="../../../assets/img/review-del.png"
              alt="delete review"
              class="review-item-img"
              @click="handleReviewAdd(i, 1)"
              v-else
            />
          </template>
          <p v-if="type === 'pop'" class="custom-review-p">{{ item.value }}</p>
          <el-input
            type="textarea"
            v-model="item.value"
            :placeholder="$t('messages.createCampaign.create64')"
            autosize
            :class="{'custom-review-input2':true,'largearea':type==='combo'}"
            @change="val => changeReview(val, i)"
            :disabled="mode === 'detail'"
            v-else
          ></el-input>
        </el-form-item>
        <template v-if="item.showErr">
          <p class="err-tip" style="margin-left: 188px;" v-if="type === 'list'">
            {{ item.tip }}
          </p>
          <p class="err-tip" v-else>
            {{ item.tip }}
          </p>
        </template>

      </div>
    </div>
    <div class="col-left-btns" v-if="type==='combo'">
      <el-button type="primary" @click="handleReviewAdd(undefined, 0)">{{$t('messages.createCampaign.create30')}}</el-button>
      <el-button
        class="ai-btn"
        @click="openGenerated('combo')"
        v-if="country && app_store_url"
      >
      {{$t('messages.createCampaign.create79')}}
        <img src="../../../assets/img/ai-new.png"/>
      </el-button>
      <el-button @click="handleImport" style="height: 28px;">{{$t('messages.home.tip58')}}</el-button>
    </div>
    <div class="col-left-foot">
      <el-pagination
        :current-page="page"
        :page-size="pageSize"
        :pager-count="pagerCount"
        @current-change="getReviewList"
        layout="prev, pager, next"
        :total="allList.length"
      ></el-pagination>
      <span class="total-custom">{{ isEn ? `Total ${listTotal}` : `共 ${listTotal} 条` }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return [
          {
            value: '',
            showErr: false,
            tip: 'Error',
          },
        ]
      },
    },
    allList: {
      type: Array,
      default() {
        return [
          {
            value: '',
            showErr: false,
            tip: 'Error',
          },
        ]
      },
    },
    type: {
      type: String,
      default: 'list',
    },
    mode: {
      type: String,
      default: 'create',
    },
    country: {
      type: String,
      default: '',
    },
    app_store_url: {
      type: String,
      default: '',
    },
    businessType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      page: 1,
      page2: 1,
      page3: 1,
      pageSize: 10,
      pagerCount:5,
      paginationTextEn: {
        total: 'Total',
        sizes: '/page',
        jumper: 'Go to',
        page: ''
      },
      paginationTextZh: {
        total: '共',
        sizes: '条/页',
        jumper: '前往',
        page: '页'
      }
    }
  },
  methods: {
    openGenerated(val){
      this.$emit('openGenerated', val)
    },
    handleImport(){
      this.$emit('handleImport', this.type)
    },
    handleReviewAdd(index, type) {
      this.$emit('handleReviewAdd', index, type, this.type)
    },
    handleDeleteAll() {
      this.$emit('handleDeleteAll')
    },
    getReviewList(val) {
      if (this.type === 'pop') {
        this.page2 = val
      } else if(this.type === 'list') {
        this.page = val
      }else{
        this.page3 = val
      }
      this.$emit('handlePageList', this.type)
    },
    changeReview(val, index) {
      this.$emit('changeReview', val, index,this.type)
    },
  },
  computed: {
    isEn(){
      return this.$i18n.locale === 'en'
    },
    listTotal(){
      return this.allList.length
    },
  }
}
</script>

<style lang="scss">
.campaignViews {
  .custom-review-item {
    flex: 1;
    margin-bottom: 10px;
    .review-item-img {
      height: 24px;
      width: 24px;
      margin-right: 14px;
      cursor: pointer;
    }
    .el-form-item__content {
      display: flex;
      margin-bottom: 6px;
    }
  }
  .custom-review-item-combo{
    .el-form-item__content{
      margin-left: 0 !important;
      flex-direction: row-reverse;
      .review-item-img{
        margin-right: 0 !important;
      }
      .custom-review-input2{
        margin-right: 14px !important;
      }
      
    }
    .largearea{
      .el-textarea__inner{
          min-height: 66px !important;
        }
      }
  }
  .custom-review-p {
    border-bottom: 1px solid #eee;
    width: 100%;
    display: flex;
    align-items: center;
    word-break: initial;
  }
  .custom-review-input2 {
    .el-textarea__inner {
      min-height: 32px !important;
      max-height: 100px;
    }
  }
  .col-left-foot {
    // margin-left: 188px;
    margin-bottom: 10px;
    display: flex;
    // justify-content: space-between;
    flex-direction: row-reverse;
  }
  .col-left-btns{
    display: flex;
    // justify-content: space-between;
    padding-right: 38px;
    flex-wrap: wrap;
    justify-content: flex-end;
    .ai-btn{
      >span{
        display: flex;
        align-items: center;
        >img{
          width: 14px;
          margin-left: 4px;
        }
      }
    }
  }
  .del-all{
    margin-right: 14px;
    height: 28px !important;
  }
}
.review-formWidth{
  width: 570px;
  min-width: 270px;
}

.campaignViews{
  .total-custom{
    line-height: 28px;padding: 2px 0;
  }
}

@media screen and (max-width: 790px) {
  .campaignViews{
    .col-left-btns{
      justify-content: center;
      .el-button{
        margin-bottom: 4px;
      }
    }
  }
}
</style>
